import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaWhatsapp } from 'react-icons/fa'
import { scrollToSection } from '../utils/scroll'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const quickLinks = [
    { id: 'home', label: 'Home' },
    { id: 'specialities', label: 'Specialities' },
    { id: 'testimonials', label: 'Testimonials' },
    { id: 'about', label: 'About Us' },
    { id: 'contact', label: 'Contact' },
  ]

  const services = [
    'Custom Weekly Scheduling',
    'Maximized Earnings',
    'Streamlined Paperwork',
    'Dedicated Support',
    'Expense Coverage',
    '24/7 Dispatch Support',
  ]

  return (
    <footer className="bg-transparent text-white border-t border-white/10 backdrop-blur-sm">
      <div className="container-custom section-padding">
        <div className="bg-black/30 backdrop-blur-sm rounded-2xl p-8 border border-white/10 shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img 
                src="/logo.png" 
                alt="EW Logistics Logo" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-gray-300">
              We specialize in Freight Consultancy and strive to provide the best possible services to our carriers. 
              Our focus is on alleviating the pressure of load sourcing and negotiations.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-300 hover:text-accent-400 transition-colors text-left"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Our Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-gray-300">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Contact Us</h3>
            <div className="space-y-3">
              <div className="contact-item">
                <FaPhone className="text-accent-400 flex-shrink-0" size={18} />
                <a href="tel:+16309841460" className="text-gray-300 hover:text-accent-300 transition-colors">
                  +1 (630) 984-1460
                </a>
              </div>
              <div className="contact-item">
                <FaEnvelope className="text-accent-400 flex-shrink-0" size={18} />
                <a href="mailto:hr@ewlogisticsusa.com" className="text-gray-300 hover:text-accent-300 transition-colors">
                  hr@ewlogisticsusa.com
                </a>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt className="text-accent-400 flex-shrink-0" size={18} />
                <span className="text-gray-300">
                  453 W Fullerton Ave<br />
                  Elmhurst, IL 60126
                </span>
              </div>
            </div>
            <div className="flex gap-2 mt-6">
              <a href="https://www.facebook.com/share/17isLvbYoN/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-accent-400 transition-colors" aria-label="Facebook">
                <FaFacebook size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-accent-400 transition-colors" aria-label="WhatsApp">
                <FaWhatsapp size={20} />
              </a>
              <a href="https://www.instagram.com/ewlogisticsllc.official?igsh=NWN3d3JheGtuenNm" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-accent-400 transition-colors" aria-label="Instagram">
                <FaInstagram size={20} />
              </a>
            </div>
          </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-white/10 mt-12 pt-8 text-center text-gray-400 space-y-2">
            <p>&copy; {currentYear} EW Logistics & IT Solution LLC. All rights reserved.</p>
            <p className="text-sm text-gray-500">
              Powered by{' '}
              <a
                href="https://vawcom.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-accent-400 transition-colors underline-offset-2 hover:underline"
              >
                VAWCOM
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
